NtechApp.ChatsListPage = function() {
    var chatMessagesForm = new NtechApp.ChatMessagesForm($("#messagesList .chatMessagesForm"));
    NtechApp.chatMessagesForm = chatMessagesForm;

    var chatsList = new NtechApp.ChatsList($("#chatsList"));
    var isInitialLoad = true;
    $(chatsList).on(NtechApp.ChatsList.EVENT_CHAT_SELECT, function(e, chatId) {
        if(isInitialLoad) {
            isInitialLoad = false;
            chatMessagesForm.openForm(chatId, true);
            return;
        }

        chatMessagesForm.openForm(chatId);
    });
    chatsList.selectLatestChatIfExists();

    var onCreateEv = NtechApp.ChatMessagesForm.EVENT_ON_NEW_MESSAGE_CREATE;
    var onSaveEv = NtechApp.ChatMessagesForm.EVENT_ON_NEW_MESSAGE_SAVE;
    $(chatMessagesForm).on(onCreateEv, function(e, chatId) {
        chatsList.moveSelectedChatToTop();
    });

    $(chatMessagesForm).on(onSaveEv, function(e, chatId, message, messageDate) {
        chatsList.processNewMessage(chatId, message, messageDate);
    });

    var onSelectEv = NtechApp.RecentChatsSelectList.EVENT_ITEM_SELECT;
    $(NtechApp.recentChatsSelectList).on(onSelectEv, function(e, chatId) {
        chatsList.selectAndScrollToChat(chatId);
    });

    $(NtechApp.chatForm).on(NtechApp.ChatForm.EVENT_NEW_CHAT_MESSAGE, function(e, chatId) {
        chatsList.selectAndScrollToChat(chatId);
    });

    var click = new NtechApp.TouchClickEvent();
    click.listen($("body"), "[data-triggerMarkAllReadControl]", function(e) {
        var $control = $(e.target).closest("[data-triggerMarkAllReadControl]").find(".formControl");
        NtechApp.chatServices.saveMarkAllRead($control);
    });
};